import React, { useMemo } from 'react';

import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import FlowIcon from '../../assets/icons/FlowIcon';

const FlowBreadcrumbs = ({ selectedFlow, selectedStep }) => {
  const breadcrumbs = useMemo(() => {
    const initial = { name: 'Flows' }

    if (selectedStep) {
      return [initial, selectedFlow, selectedStep];
    }

    if (selectedFlow) {
      return [initial, selectedFlow];
    }

    return [initial];
  }, [selectedFlow, selectedStep]);

  return (
    <div className='drive-breadcrumbs__container'>
      <FlowIcon className='m-r-md' color="var(--app-text)" style={{ fontSize: '24px' }} />
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize='small' style={{ color: 'var(--app-text-subtle)' }} />}
        aria-label='breadcrumb'
        maxItems={4}
      >
        {breadcrumbs.map((item) => (
          <div
            key={Math.random()}
            className='drive-breadcrumbs__item'
            style={{ cursor: 'default' }}
          >
            {item?.name || item?.title}
          </div>
        ))}
      </Breadcrumbs>
    </div>
  );
};

export default FlowBreadcrumbs;
